import {
  Box,
  Card,
  Container,
  Grid,
  Backdrop,
  CircularProgress
} from '@mui/material';
import ReimbursementResult from './ReimbursementResult';
import ReimbursementToolbar from './ReimbursementToolbar';
import commonService from 'src/service/common';
import { _reimbursementAxios } from 'src/plugins/axios';
import { useEffect, useState } from 'react';
import csvDownload from 'json-to-csv-export';
import { userLogout } from '../../../../utils/userLogout';
const ReimbursementMain = () => {
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(5);
  const [level1Claims, setLevel1Claims] = useState([]);
  const [actedClaims, setActedClaims] = useState([]);
  const [searchedClaim, setSearchedClaim] = useState([]);
  const [payload, setPayload] = useState();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState();
  const [activeTab, setActiveTab] = useState(0);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [bulkClaims, setBulkClaims] = useState([]);
  const [ nextActionItems, setNextActionItems] = useState([]);

  const [toolBarClaimStatuses, setToolBarClaimStatuses] = useState({
    'pre approved': true,
    'pre rejected': true,
    'partially pre approved': true,
    'raised for payment': true,
    'information required': true,
    'submitted': true,
    'resubmitted': true
  });
  const firstDateOfTheYear = new Date(new Date().getFullYear(), 0, 1);
  let today = new Date();
  today.setDate(today.getDate() + 1);
  const [startDate, setStartDate] = useState(
    firstDateOfTheYear.toISOString().split('T')[0]
  );
  const [endDate, setEndDate] = useState(today.toISOString().split('T')[0]);
  const [toolBarCorporates, setToolBarCorporates] = useState();
  const [entityListData, setEntityListData] = useState({});

  useEffect( () => {
    fetchEntityData();
  }, []);

  const onFilterHandler = async (payLoad) => {
    if (payLoad) {
      setPayload(payLoad);
      setLoading(true);
      if(payLoad.activeTab == 0 || payLoad.activeTab == 1)
      {
        _reimbursementAxios
        .post('reimbursement/claims', payLoad, {
          ignoreLoading: true,
          headers: {
            authtoken: commonService.getAuthToken(),
            'Content-Type': 'application/json'
          }
        })
        .then((response) => {
          if (response.data && response.data.isSuccess) {
            if (response.data.result.length > 0) {
              if (payLoad.activeTab === 0)
                setLevel1Claims(response.data.result);
              else setActedClaims(response.data.result);
              setMessage();
            } else {
              if (payLoad.activeTab === 0)
                setLevel1Claims(response.data.result);
              else setActedClaims(response.data.result);
              setMessage('Sorry, no claims match your search criteria');
            }
            if(response.data.nextActionItems){
              setNextActionItems(response.data.nextActionItems);
            }
     
          } else {
            if (response.data.message) setMessage(response.data.message);
            else setMessage('Oops something went wrong please try again');
          }
          setTimeout(() => {
            setLoading(false);
          }, 500);
        })
        .catch((error) => {
          //if 401, user session expired, logout the user
          if(error?.response?.status === 401 || error?.response?.status === 403){
            userLogout();
          } 

          setTimeout(() => {
            setLoading(false);
          }, 500);
          setMessage('Unable to fetch claims');
        });
      }
        else if(payLoad.activeTab == 2){
          _reimbursementAxios
        .post('reimbursement/claimsUnderQuery', payLoad, {
          ignoreLoading: true,
          headers: {
            authtoken: commonService.getAuthToken(),
            'Content-Type': 'application/json'
          }
        })
        .then((response) => {
          console.log(JSON.stringify(payLoad.activeTab))
          if (response.data && response.data.isSuccess) {
            if (response.data.result.length > 0) {
              setSearchedClaim(response.data.result);
            } else {
              setMessage('Sorry, no claims match your search criteria');
            }
          } else {
            if (response.data.message) setMessage(response.data.message);
            else setMessage('Oops something went wrong please try again');
          }
          setTimeout(() => {
            setLoading(false);
          }, 500);
        })
        .catch((error) => {
          //if 401, user session expired, logout the user
          if(error?.response?.status === 401 || error?.response?.status === 403){
            userLogout();
          } 

          setTimeout(() => {
            setLoading(false);
          }, 500);
          setMessage('Unable to fetch claims');
        });

        }
    } else {
      window.location.reload();
    }
    setSearchedClaim([]);
    setPage(0);
    setLimit(5);
    setIsCheckAll(false);
    setIsCheck([]);
    setBulkClaims([]);
  };

  const downloadResults = () => {
    let json_data = [];
    if (activeTab == 1) {
      json_data = actedClaims;
    } else {
      json_data = level1Claims;
    }
    let condensed_json_data = [];
    if (json_data && json_data.length > 0) {
      json_data.forEach((ele) => {
        if (!(ele.employeeid && ele.employeeid.includes('test'))) {
          condensed_json_data.push({
            'Claim Amount': ele.claimamount || 0,
            'Employee ID': ele.employeeid || '',
            'Medibuddy Remarks': ele.remarks || '',
            'Claim Id': ele.claimid || null,
            'Amount approved for claim': ele.approvedclaimamount || 0,
            'Patient Name': ele.name || '',
            'Payment Status': ele.paymentstatus || '',
            UTR: ele.utr || '',
            'ABHI action remark': ele.clientclaimremark || '',
            'Patient Email Id': ele.emailid || '',
            'Patient Phone Number': ele.phonenumber || '',
            'Amount deducted from employee wallet': ele.deductedamount || 0
          });
        }
      });
    }
    if (condensed_json_data.length > 0) {
      const data_to_download = {
        data: condensed_json_data,
        filename: 'claims_data',
        delimiter: ',',
        headers: Object.keys(condensed_json_data[0])
      };
      csvDownload(data_to_download);
    }
  };

  const onSearchHandler = (payLoad) => {
    setLoading(true);
    _reimbursementAxios
      .post('reimbursement/searchClaim', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          if (response.data.result.length > 0) {
            setSearchedClaim(response.data.result);
            setMessage();
          } else {
            if (payLoad.activeTab === 0)
              setMessage('No claim present in level one with this claim id');
            else setMessage('No claim present in actioned with this claim id');
          }
          setTimeout(() => {
            setLoading(false);
          }, 500);
        } else {
          if (response.data.message) setMessage(response.data.message);
          else setMessage('Oops something went wrong please try again');
          setTimeout(() => {
            setLoading(false);
          }, 500);
        }
      })
      .catch((error) => {
        //if 401, user session expired, logout the user
        if(error?.response?.status === 401 || error?.response?.status === 403){
          userLogout();
        }

        setMessage('Unable to fetch claims');
        setTimeout(() => {
          setLoading(false);
        }, 500);
      });
      setPage(0);
      setLimit(5);
  };

  const onChangeTab = async (tab) => {
    setSearchedClaim([]);
    setLoading(true);
    setActiveTab(tab);
    if (tab == 0) {
      updateToolBarClaimStatusSelections([
        'pre approved',
        'pre rejected',
        'partially pre approved',
        'raised for payment',
        "information required",
        "submitted",
        "resubmitted"
      ]);
    } else if(tab == 1) {
      updateToolBarClaimStatusSelections([
        'approved',
        'rejected',
        'partially approved',
        'recheck'
      ]);
    } else if(tab == 2){
      updateToolBarClaimStatusSelections([
      ]);
    }
    let payLoad = {};
    if (tab == 0) {
      payLoad['activeTab'] = 0;
    } else if (tab == 1) {
      payLoad['activeTab'] = 1;
    } else if (tab == 2){
      payLoad['activeTab'] = 2;
    }
    let claimStatuses =
      tab == 0
        ? ['pre approved', 'pre rejected', 'partially pre approved','raised for payment',"information required","submitted", "resubmitted"]
        : ['approved', 'rejected', 'partially approved', 'recheck' ];
    payLoad['claimStatus'] = claimStatuses ? claimStatuses : null;
    payLoad['startDate'] = startDate ? startDate : null;
    payLoad['endDate'] = endDate ? endDate : null;
    payLoad['corporate'] = toolBarCorporates ? toolBarCorporates : null;
    onFilterHandler(payLoad);
  };

  const updateToolBarClaimStatusSelections = (selectOptions) => {
    if (selectOptions) {
      let newSelection =
      activeTab == 2 ? {}:
        activeTab == 0
          ? {
              'pre approved': false,
              'pre rejected': false,
              'partially pre approved': false,
              'raised for payment': false,
              "information required": false,
              "submitted": false,
              "resubmitted": false,
            }
          : {
              approved: false,
              rejected: false,
              'partially approved': false,
              recheck: false
            };
      selectOptions.forEach((ele) => {
        newSelection[ele] = true;
      });
      setToolBarClaimStatuses(newSelection);
    }
  };

  const pageHandler = (page) => {
    setPage(page);
  }

  const limitHandler = (limit) => {
    setLimit(limit);
  }

  const updateToolBarCorporateSelections = (corporateId) => {
    console.log(corporateId);
    setToolBarCorporates(corporateId);
  };

  const updateToolBarDateRange = (startDate, endDate) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const selectAllHandler = (selectAllFlag) => {
    setIsCheckAll(selectAllFlag);
  }

  const isSelectHandler = (selectedClaims) => {
    setIsCheck(selectedClaims);
  }

  const isBulkSelectHandler = (bulkselectedClaims) => {
    setBulkClaims(bulkselectedClaims);
  }

  const fetchEntityData = async () => {
    try {
      setLoading(true);
      const response = await _reimbursementAxios.post(
        'reimbursement/childEntityMapping',
        {
          accesstoken: commonService.getAuthToken()
        },
        {
          headers: {
            authtoken: commonService.getAuthToken(),
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data && response.data.isSuccess) {
        setEntityListData(response.data.entityNameMapping);
        setLoading(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  return (
    <>
      {
        <>
          <Box sx={{ backgroundColor: 'background.default', py: 2 }}>
            {' '}
            <Grid item sx={{ marginLeft: 3 }}>
              <ReimbursementToolbar
                onFilter={onFilterHandler}
                onSearch={onSearchHandler}
                activeTab={activeTab}
                claimStatusSelections={toolBarClaimStatuses}
                updateToolbarClaimStatues={updateToolBarClaimStatusSelections}
                corporateSelections={toolBarCorporates}
                updateCorporateSelections={updateToolBarCorporateSelections}
                dateSelections={[startDate, endDate]}
                updateDateSelections={updateToolBarDateRange}
                entityListData = {entityListData}
              />
            </Grid>
          </Box>
          <Container maxWidth={false}>
            <Grid container>
              <Grid item xs={12}>
                <Card
                  sx={{
                    width: '100%',
                    borderRadius: 4,
                    mb: 2,
                    mt: 4,
                    p: 3,
                    boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)'
                  }}
                >
                  <ReimbursementResult
                    actedClaims={actedClaims}
                    level1Claims={level1Claims}
                    searchedClaim={searchedClaim}
                    message={message}
                    onFilter={onFilterHandler}
                    changeTab={onChangeTab}
                    payload={payload}
                    page={page}
                    limit={limit}
                    pageHandler={pageHandler}
                    limitHandler={limitHandler}
                    selectAllHandler={selectAllHandler}
                    isSelectAll={isCheckAll}
                    isSelectHandler={isSelectHandler}
                    isCheck={isCheck}
                    isBulkSelectHandler={isBulkSelectHandler}
                    bulkClaims={bulkClaims}
                    nextActionItems = {nextActionItems}
                    downloadResults={() => {
                      downloadResults();
                    }}
                    entityListData = {entityListData}
                  />
                </Card>
              </Grid>
            </Grid>
          </Container>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
      }
    </>
  );
};

export default ReimbursementMain;
